import { APP_SETTINGS } from "../../config";
import axios from "axios";
import { data } from "jquery";

function fetchProjectsByFilter(data, token) {
  var response = axios.post(
    APP_SETTINGS.API_PATH.PROJECTS.getProjectsByAllFilter,
    data,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response;
}

function fetchProjectsByEmployee(organizationId, empId, token) {
  const url = `${APP_SETTINGS.API_PATH.PROJECTS.getProjectsByEmployee}/${organizationId}/${empId}`;
  // const url = `${APP_SETTINGS.API_PATH.PROJECTS.getProjectsByEmployee}/2`;


  return axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

function removeUserFromProject(projectId, userId, token) {
  const url = `${APP_SETTINGS.API_PATH.TASK.removeEmployee}?projectId=${projectId}&userId=${userId}`;


  return axios.post(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}
function fetchEmployeeTasksByProject(organizationId, empId, projectId, token) {
  const url = `${APP_SETTINGS.API_PATH.PROJECTS.getEmployeeTasksByProject}/${organizationId}/${empId}/${projectId}`;


  return axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

function fetchProjects(requestId, token) {
  var response = axios.post(
    APP_SETTINGS.API_PATH.PROJECTS.getProjects,
    { requestId: requestId },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response;
}

function fetchProjectCategory(requestId, token) {
  return axios.post(
    APP_SETTINGS.API_PATH.PROJECTS.PROJECTCATEGORY.getProjectCategory,
    { requestId },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
}

function fetchProjectInfo(token) {
  return axios.get(APP_SETTINGS.API_PATH.PROJECTS.getProjectInfo, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

function removeProject(requestId, token) {
  return axios.post(
    APP_SETTINGS.API_PATH.PROJECTS.deleteProject,
    { requestId },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
}

function changeProject(projectData, token) {
  return axios.post(
    APP_SETTINGS.API_PATH.PROJECTS.addEditProject,
    projectData,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
}

function getProjectSelectListByRoleApi(orgId, token) {
  return axios.get(
    `${APP_SETTINGS.API_PATH.PROJECTS.getProjectSelectListByRole}?organizationId=${orgId?.organizationId}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
}
function getDeleteProjectListApi(projectDelete, token) {
  return axios.post(
    APP_SETTINGS.API_PATH.SETTING_TRASH.getDeleteList,
    projectDelete,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
}

function restoreDeleteProjectApi(restoreProject, token) {
  return axios.post(
    APP_SETTINGS.API_PATH.SETTING_TRASH.restoreDeleteProject,
    restoreProject,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
}
function emptyTrashApi(orgId, token) {
  return axios.get(
    `${APP_SETTINGS.API_PATH.SETTING_TRASH.emptyTrash}?organizationId=${orgId?.organizationId}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
}
function deleteTrashProjectApi(projectId, token) {
  return axios.get(
    `${APP_SETTINGS.API_PATH.SETTING_TRASH.deleteTrashProject}?projectId=${projectId?.projectId}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
}
export {
  fetchProjects,
  fetchProjectsByFilter,
  fetchProjectCategory,
  changeProject,
  removeProject,
  fetchProjectInfo,
  getProjectSelectListByRoleApi,
  getDeleteProjectListApi,
  restoreDeleteProjectApi,
  emptyTrashApi,
  deleteTrashProjectApi,
  fetchProjectsByEmployee,
  fetchEmployeeTasksByProject,
  removeUserFromProject,
};
